import { pageMeta } from '../../constants/pageMeta';
import { CALL_NOTE, COMPANY_NAME, SITE_DOMAIN, SITE_NAME } from '../../constants/site';
import PolicyPage, { ContactBlock, Section } from '../components/PolicyPage';

const META = pageMeta(
  'Disclaimer',
  `${SITE_NAME} is an independent travel agency run by ${COMPANY_NAME} and is not affiliated with any airline or travel provider.`,
  '/disclaimer'
);

export default function DisclaimerPage() {
  return (
    <PolicyPage title="Disclaimer" meta={META} intro={`Important information about ${SITE_NAME} and ${SITE_DOMAIN}.`}>
      <Section title="1. Independent travel agency">
        <p>
          {SITE_NAME} is a trade name of {COMPANY_NAME}, an independent travel agency affiliated with Fora Travel. We are
          not an airline, hotel, car rental company, cruise line or tour operator, and we are not affiliated with,
          endorsed by, sponsored by or acting on behalf of any travel provider unless we say so in writing.
        </p>
      </Section>

      <Section title="2. Phone calls">
        <p>
          {CALL_NOTE} Our advisors can make and manage bookings made through us. We cannot act as any provider’s
          official customer service, and some requests can only be handled by the provider directly.
        </p>
      </Section>

      <Section title="3. Prices and availability">
        <p>
          This website does not show live prices. Any example prices or descriptions are for general information only.
          Prices and availability are set by travel providers, change constantly and are only confirmed when your
          booking is issued.
        </p>
      </Section>

      <Section title="4. Trademarks">
        <p>
          Airline, hotel, cruise line and other brand names that may be mentioned on this website or in our
          communications belong to their owners. They are used only to describe travel options and do not mean those
          companies endorse or work with us.
        </p>
      </Section>

      <Section title="5. General information">
        <p>
          Travel information on this website, such as destination descriptions, is general and may change. Always
          check entry requirements, visas and health advice with official government sources before you travel.
        </p>
      </Section>

      <Section title="6. Images">
        <p>Photos on this website are illustrative and may not show the exact property, ship, vehicle or aircraft you book.</p>
      </Section>

      <Section title="7. Contact us">
        <ContactBlock />
      </Section>
    </PolicyPage>
  );
}
